// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { Parliamentarian } from './types';
import { partyStyle, chamberColour } from './parties';
import { escapeHtml, fmtDollars, stateName } from './format';

export function partyPill(code: string, name?: string): string {
  const ps = partyStyle(code);
  return `<span class="pill" style="background:${ps.colour}"><span class="dot"></span>${escapeHtml(name ?? ps.name)}</span>`;
}

export function chamberTag(chamber: string): string {
  return `<span class="chamber-tag" style="background:${chamberColour(chamber)}">${escapeHtml(chamber)}</span>`;
}

export function seatLabel(p: Parliamentarian): string {
  if (p.chamber === 'Senate') return `Senator, ${escapeHtml(p.state ?? '')}`;
  if (p.electorate) return `${escapeHtml(titleCaseSeat(p.electorate))}${p.state ? ', ' + escapeHtml(p.state) : ''}`;
  return escapeHtml(p.role ?? '—');
}

export function titleCaseSeat(s: string): string {
  return s.toLowerCase().replace(/\b([a-z])/g, (m) => m.toUpperCase());
}

export function statCard(label: string, value: string, sub?: string): string {
  return `<div class="stat-card"><div class="label">${escapeHtml(label)}</div><div class="value">${value}</div>${sub ? `<div class="sub">${sub}</div>` : ''}</div>`;
}

export function tipFor(p: Parliamentarian): string {
  return `${p.name} (${partyStyle(p.partyCode).name})\n${seatText(p)}\nTotal: ${fmtDollars(p.total)}`;
}

function seatText(p: Parliamentarian): string {
  if (p.chamber === 'Senate') return `Senator for ${stateName(p.state ?? '')}`;
  if (p.electorate) return `Member for ${titleCaseSeat(p.electorate)}`;
  return p.role ?? '';
}
